import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <div className="max-w-screen-lg mx-auto px-6 md:px-12 py-16">
        <Link 
          to="/" 
          className="text-neutral-400 hover:text-white transition-colors text-sm mb-8 inline-block"
        >
          ← Back to Home
        </Link>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-tight mb-8">
            Terms & Conditions
          </h1>
          
          <p className="text-neutral-400 text-sm mb-8">
            Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
          
          <div className="space-y-8 text-neutral-300 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">1. Introduction</h2>
              <p>
                These Terms and Conditions ("Terms") govern your use of the website simplysmarter.io ("Website") operated by Simply Smarter Ltd ("we", "our", or "us"), a company registered in Scotland (Registration Number: SC867185).
              </p>
              <p className="mt-4">
                By accessing or using our Website, you agree to be bound by these Terms. If you do not agree to these Terms, please do not use our Website.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">2. Company Information</h2>
              <address className="not-italic text-neutral-400">
                Simply Smarter Ltd<br />
                Registered in Scotland: SC867185<br />
                Clyde Offices, 2nd floor<br />
                48 West George Street<br />
                Glasgow, U.K.<br />
                G2 1BP<br />
                Email: <a href="mailto:hello@simplysmarter.io" className="text-white hover:underline">hello@simplysmarter.io</a>
              </address>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">3. Use of Website</h2>
              <p>You agree to use our Website only for lawful purposes and in a way that does not:</p>
              <ul className="list-disc list-inside mt-4 space-y-2 text-neutral-400">
                <li>Infringe the rights of any third party</li>
                <li>Restrict or inhibit anyone else's use of the Website</li>
                <li>Violate any applicable laws or regulations</li>
                <li>Transmit any harmful, offensive, or illegal content</li>
                <li>Attempt to gain unauthorised access to our systems</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">4. Intellectual Property</h2>
              <p>
                All content on this Website, including but not limited to text, graphics, logos, images, and software, is the property of Simply Smarter Ltd or its licensors and is protected by UK and international copyright, trademark, and other intellectual property laws.
              </p>
              <p className="mt-4">
                You may not reproduce, distribute, modify, or create derivative works from any content on this Website without our prior written consent.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">5. Disclaimer</h2>
              <p>
                The information on this Website is provided "as is" without any warranties, express or implied. We do not warrant that:
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2 text-neutral-400">
                <li>The Website will be available at all times or be error-free</li>
                <li>The information on the Website is complete, accurate, or up-to-date</li>
                <li>The Website is free from viruses or other harmful components</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">6. Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, Simply Smarter Ltd shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Website.
              </p>
              <p className="mt-4">
                Nothing in these Terms excludes or limits our liability for death or personal injury caused by our negligence, fraud or fraudulent misrepresentation, or any other liability that cannot be excluded or limited by law.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">7. Third-Party Links</h2>
              <p>
                Our Website may contain links to third-party websites. These links are provided for your convenience only. We have no control over the content of these sites and accept no responsibility for them or for any loss or damage that may arise from your use of them.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">8. Changes to Terms</h2>
              <p>
                We reserve the right to modify these Terms at any time. Any changes will be posted on this page with an updated revision date. Your continued use of the Website after any changes constitutes your acceptance of the new Terms.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">9. Severability</h2>
              <p>
                If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall continue in full force and effect.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">10. Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of Scotland. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the Scottish courts.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">11. Contact Us</h2>
              <p>
                If you have any questions about these Terms, please contact us at:
              </p>
              <p className="mt-4">
                Email: <a href="mailto:hello@simplysmarter.io" className="text-white hover:underline">hello@simplysmarter.io</a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsConditions;
